import { ICredentials } from '@aws-amplify/core';
import React from 'react';

// Enumerators
// //////////////////////////

export interface IsFederatedUserPayload {
  federationName: string;
  federationId: string;
  enabled: boolean;
  userData: Record<string, unknown>;
  configData: Record<string, unknown>;
}

export interface AuthContext {
  route:
    | 'idle'
    | 'signIn'
    // 'confirmSignIn' | // For MFA confirmation
    | 'forceNewPassword'
    | 'resetPassword'
    | 'confirmResetPassword'
    | 'signOut'
    | 'authenticated';
  inProgress: boolean;
  error: string | null;

  user: Record<string, unknown>;

  federatedSignIn: (customState: string) => Promise<ICredentials>;
  signIn: (username: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  resetPassword: (username: string) => Promise<void>;
  confirmResetPassword: (
    username: string,
    code: string,
    password: string,
  ) => Promise<void>;
  completeNewPassword: (password: string) => Promise<void>;
  setRoute: React.Dispatch<React.SetStateAction<AuthContext['route']>>;
  getUserFederations: (username: string) => Promise<IsFederatedUserPayload[]>;
}

// Context
// //////////////////////////

// The initial authorization context
const authContext = React.createContext<AuthContext>({
  route: 'idle',
  inProgress: false,
  error: null,
  user: {},
  federatedSignIn: async () => ({
    accessKeyId: '',
    sessionToken: '',
    secretAccessKey: '',
    identityId: '',
    authenticated: false,
  }),
  signIn: async () => {},
  signOut: async () => {},
  resetPassword: async () => {},
  confirmResetPassword: async () => {},
  completeNewPassword: async () => {},
  setRoute: () => null,
  getUserFederations: async () => [],
});

export default authContext;
